var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureLicensesLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.667,
    height: 11.667,
    x: 28.167,
    y: 0.458,
    fill: "#EEF0F3",
    rx: 1.458
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.667,
    height: 11.667,
    x: 55.875,
    y: 55.875,
    fill: "#EEF0F3",
    rx: 1.458
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.667,
    height: 11.667,
    x: 0.458,
    y: 55.875,
    rx: 1.458
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.84 12.125L58.547 55.875M9.453 55.875L33.16 12.125M55.875 61.708L12.125 61.708"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLicensesLarge);
export default __webpack_public_path__ + "static/media/azure-licenses-large.e402ce024d04ace995c5d5c7cbee9740.svg";
export { ForwardRef as ReactComponent };